import { useEffect, useState } from "react";
import InputRegister from "../../../layouts/ui/InputRegister";

export const Disability = ({ Information, errors, setErrors, candidate }) => {
    const [disability, setDisability] = useState({
        isDisabled: false,
        desc: "",
    });

    const checkValidation = (status, value) => {
        if (status && !value.trim()) {
            setErrors((prev) => ({ ...prev, disabilityDescription: "Description is required" }));
        }
        else {
            setErrors((prev) => ({ ...prev, disabilityDescription: "" }));
        }
    }

    const handleChange = (option) => {
        setDisability((prev) => {
            let tempDisability = {...prev}
            tempDisability.isDisabled = option
            if(!option){
                tempDisability.desc = ""
            }
            return tempDisability
        })
        checkValidation(option, disability.desc)
    }

    const handleDescChange = (val) => {
        setDisability((prev) => ({ ...prev, desc: val }));
        checkValidation(disability.isDisabled, val)
    };

    useEffect(()=>{
        if (candidate.disability) {
            const tempDisability = candidate.disability
            setDisability({
                isDisabled: tempDisability.isDisabled || false,
                desc: tempDisability.desc || "",
            })
        }
        
    },[candidate])

    useEffect(()=>{
       if(Information){
           Information(disability)
       }
    }, [disability])

    return (
        <div>
            <div className="bg-white border rounded-2xl p-4">
                <h4 className="font-medium mb-2">Do you have a disability?</h4>
                <div className="mb-3 flex items-center gap-6">
                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="hasDisability"
                            checked={disability.isDisabled === true}
                            onChange={() => handleChange(true)}
                        />
                        <span className="ml-1">Yes</span>
                    </label>

                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="hasDisability"
                            checked={disability.isDisabled === false}
                            onChange={() => handleChange(false)}
                        />
                        <span className="ml-1">No</span>
                    </label>
                </div>

                {disability.isDisabled && (
                    <div>
                        <InputRegister
                            label="If yes, describe here"
                            value={disability.desc}
                            onChange={(e) => handleDescChange(e.target.value)}
                            placeholder="Write a short note"
                            error={errors.disabilityDescription || ""}
                            className="w-full"
                            border={true}
                        />
                        <p>This Information will kept confidential and only used to ensure equal opportunities.</p>
                    </div>
                )}
            </div>
        </div>
    );
};
